import { color } from '@my/util'
import { SimpleText, useWindowDimensions, XStack, YStack } from '@my/ui'
import { shadowGenerator } from '../../../../utils/commonStyles'

const textColors = { high: color.lightRed, low: color.tzaGreen }
const bgColors = { high: color.opaqueRed, low: 'rgba(133, 193, 157, 0.21)' }

// Reusable component for displaying the priority badge
export const PriorityBadge: React.FC<FinancialPriorityBadgeProps> = ({ priority, time }) => (
  <YStack
    borderRadius={100}
    paddingHorizontal={10}
    alignItems="center"
    justifyContent="center"
    backgroundColor={bgColors[priority] ?? 'rgba(133, 193, 157, 0.21)'}
    height={30}
  >
    <SimpleText
      color={textColors[priority]}
      fontSize={12}
      numberOfLines={2}
      textAlign="center"
      fontWeight="700"
    >
      {time}
    </SimpleText>
  </YStack>
)

const FinancialSummaryyCard: React.FC<FinancialSummaryCardProps> = ({
  status,
  value,
  time,
  priority,
}) => {
  return (
    <XStack
      flex={1}
      justifyContent="space-between"
      height={90}
      bg={color.white}
      borderRadius={10}
      maxWidth={320}
      minWidth={310}
      padding={15}
      {...shadowGenerator(0.2)}
    >
      <YStack gap={5}>
        <SimpleText fontSize={24} fontWeight="700" color={color.grey}>
          {value}
        </SimpleText>
        <SimpleText fontSize={18} fontWeight="600" color={color.tzaGreen}>
          {status}
        </SimpleText>
      </YStack>
      <PriorityBadge priority={priority} time={time} />
    </XStack>
  )
}

export const FinancialSummary: React.FC<FinancialSummaryProps> = ({ header, listData }) => {
  const width = useWindowDimensions().width
  return (
    <YStack gap={25}>
      {header && (
        <SimpleText fontSize={19} fontWeight="800" color={color.tzaGreen}>
          {header}
        </SimpleText>
      )}

      <XStack
        justifyContent="space-between"
        $platform-web={{
          width: width < 800 ? '100%' : '95%',
        }}
        flexDirection={'row'}
        flexWrap="wrap"
        gap={20}
      >
        {!!listData?.length &&
          listData?.map((item, index) => (
            <FinancialSummaryyCard key={index} title={item?.title} value={item?.value} {...item} />
          ))}
      </XStack>
    </YStack>
  )
}
